import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { createSonarSelector } from '@lib/selectors';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';

const stateSelector = createSonarSelector((state) => state.core.initiatives.sonarObjects.delete);

export const RemovePeriscopeFromInitiativeNotification: React.FC = () =>
	<AsyncStateNotification
		errored={ NOTIFICATIONS_COPY.ERROR_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID }
		failed={ NOTIFICATIONS_COPY.FAILED_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID }
		received={ NOTIFICATIONS_COPY.SUCCESS_DELETE_INITIATIVES_BY_INITIATIVE_ID_SONAR_OBJECTS_BY_ID }
		resetRawAction={ coreActions.resetDeleteCoreInitiativesSonarObjects }
		stateSelector={ stateSelector } />;

